
// Define regions for filtering
export const regions = {
  "South West UK": ["Bristol", "Bath", "Exeter", "Plymouth", "Truro", "Taunton"],
  "London & South East": ["London", "Brighton", "Oxford", "Reading", "Southampton"],
  "Midlands": ["Birmingham", "Nottingham", "Leicester", "Coventry"],
  "North UK": ["Manchester", "Liverpool", "Leeds", "Newcastle", "York"],
  "Scotland": ["Edinburgh", "Glasgow", "Aberdeen", "Dundee"],
  "Wales": ["Cardiff", "Swansea", "Newport"],
  "Northern Ireland": ["Belfast", "Derry"],
  "Europe": ["Paris", "Berlin", "Amsterdam", "Barcelona", "Rome"],
  "North America": ["New York", "San Francisco", "Toronto", "Vancouver"],
  "Asia & Pacific": ["Tokyo", "Sydney", "Singapore", "Auckland"],
  "Other": []
};
